module.exports = {
      id: "slider-right-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#slider-right-arrow",
      toString: function () {
        return this.url;
      }
    }